var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('i',{class:_vm.iconClass,style:(_vm.iconStyle)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }